import { IconButton } from '@coolblue-development/becky';
import CassieLogo from '../../assets/cassie.svg';
import { CASSIE_PWA_PROTOCOL_URL } from './constants';

const CassieShowButton: React.FC = () => {
  const handleOnShowCassieClick = (): void => {
    window.open(CASSIE_PWA_PROTOCOL_URL, '_blank');
  };

  return (
    <IconButton
      onClick={handleOnShowCassieClick}
      preset="secondary"
      size="small"
      sx={{ svg: { width: '20px', height: '24px' } }}
    >
      <CassieLogo />
    </IconButton>
  );
};

export default CassieShowButton;
